import { useLanguage } from "../i18n";

export const LangToggle = ({ dark = false }) => {
  const { lang, setLang } = useLanguage();
  const base = dark
    ? "border-white/20 text-white/70"
    : "border-[#0D1B2A]/15 text-[#0D1B2A]/70";
  return (
    <div
      className={`inline-flex items-center rounded-full border p-0.5 text-xs font-semibold tracking-widest ${base}`}
      role="group"
      aria-label="Language"
    >
      {["es", "en"].map((l) => (
        <button
          key={l}
          data-testid={`language-toggle-${l}`}
          onClick={() => setLang(l)}
          className={`rounded-full px-3 py-1.5 uppercase transition-colors duration-300 ${
            lang === l
              ? dark
                ? "bg-white text-[#0D1B2A]"
                : "bg-[#0D1B2A] text-[#FAF6F0]"
              : "hover:opacity-100 opacity-70"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};

export default LangToggle;
